import styled from 'styled-components'
import {Button} from "@mui/material";

import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';

export const Page = styled.div`
  height: 100%;
  overflow: auto;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
`

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem 0;
    flex-wrap: wrap;
    justify-content: space-between;

    @media only screen and (max-width: 800px) {
        gap: 0;
    }
`

export const PopupContainer = styled.div`
    padding: 1.5rem 1rem;
    border-radius: 8px;
    background: white;
    max-width: 25.75rem;
    width: 100%;
    align-self: center;
`

export const TitleContainer = styled.div`
    padding: 1.275rem 1rem;
    border-radius: 8px;
    background-color: #F3F6F7;
`

export const Title = styled.div`
    margin-bottom: 8px;
    font-size: var(--typography-h5-size);
    line-height: 1.3;
    color: #000;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
`

export const Subtitle = styled.div`
  margin-bottom: 4px;
  font-size: var(--typography-body2-size);
  line-height: 1.3;
  color: #000;
  font-weight: 500;
`

export const SubtitleSecondary = styled(Subtitle)`
    font-size: 14px;
    line-height: 1.3;
    font-weight: 400;
    color: #000;
    opacity: 60%;
    margin-top: 0.5rem;
`

export const CancellationLabelWrapper = styled.div`
    margin-top: 8px;
`

export const StatusBox = styled.div`
    height: 1.75rem;
    padding: 0 0.6rem;
    background-color: var(--success-main);
    border-radius: 2rem;
    width: fit-content;
    color: white;
    display: flex;
    align-items: center;
`

export const StatusBoxPending = styled(StatusBox)`
    background-color: var(--error-main);
`

export const ShiftBox = styled.div`
    display: flex;
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 143%; /* 20.02px */
    letter-spacing: 0.15px;
`

export const ShiftBoxDate = styled.div`
    padding-right: 2rem;
    display: flex;
    align-items: center;
`

export const ShiftBoxTime = styled.div`
    display: flex;
    align-items: center;
`

export const ButtonBox = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;
`

export const LinkButton = styled.a`
    border-radius: var(--borderRadius, 8px);
    background: var(--common-white-main, #FFF);
    display: flex;
    padding: var(--2, 1rem);
    justify-content: center;
    align-items: center;
    flex: 1 0 0;

    color: var(--text-primary, rgba(0, 0, 0, 0.87));
    font-family: var(--fontMain, 'Poppins', sans-serif),sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: var(--3, 1.5rem); /* 171.429% */
    letter-spacing: 0.4px;
    flex-direction: row;
    text-transform: none;
    gap: 0.5rem;
`

export const DefaultButton = styled(Button)`
    border-radius: var(--borderRadius, 8px);
    background: var(--common-white-main, #FFF);
    display: flex;
    padding: var(--2, 1rem);
    justify-content: center;
    align-items: center;
    flex: 1 0 0;

    color: var(--text-primary, rgba(0, 0, 0, 0.87));
    font-family: var(--fontMain, 'Poppins', sans-serif),sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: var(--3, 1.5rem); /* 171.429% */
    letter-spacing: 0.4px;
    flex-direction: row;
    text-transform: none;
    gap: 0.5rem;
`

export const MapIcon = styled(MapOutlinedIcon)`
    color: #FB7672;
`

export const SecondaryMapIcon = styled(MapOutlinedIcon)`
    color: var(--secondary-main, #0B4598) !important;
`

export const ChatIcon = styled(ChatBubbleOutlineOutlinedIcon)`
    color: var(--secondary-main, #0B4598)
`

export const OutlinedButton = styled(Button)`
border-radius: var(--borderRadius, 8px);
background: none;
border-color: var(--secondary-main, #0B4598) !important;
display: flex;
justify-content: center;
align-items: center;

color: var(--secondary-main, #0B4598) !important;
font-family: var(--fontMain, 'Poppins', sans-serif),sans-serif;
font-style: normal;
font-weight: 100 !important;
letter-spacing: 0.4px;
flex-direction: row;
text-transform: none;
border-radius: 50px;
`

export const ContainedButton = styled(Button)`
border-radius: var(--borderRadius, 8px);
background: var(--secondary-main, #0B4598) !important;
display: flex;
justify-content: center;
align-items: center;

color: #fff !important;
font-family: var(--fontMain, 'Poppins', sans-serif),sans-serif;
font-style: normal;
font-weight: 100 !important;
letter-spacing: 0.4px;
flex-direction: row;
text-transform: none;
margin-bottom: 0.5rem;
border-radius: 50px;
`

export const OfferRate = styled.div`
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.3;
    color: #000;
`
export const OfferRateWrapper = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
@media only screen and (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
`

export const OfferTimerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`
